import { FC } from 'react';
import classNames from 'classnames';

import { COLORS } from 'consts';
import { formatPrice } from 'utils/text-helpers';

type BidItemProps = {
  bidNumber: number;
  bidder: string;
  bidAmountCents: number;
  timePlaced: string;
  isOwn?: boolean;
  rowNumber: number;
  maxBidCents?: number | null;
  auctionLive: boolean;
};

export const BidItem: FC<BidItemProps> = ({
  bidNumber,
  bidder,
  bidAmountCents,
  timePlaced,
  isOwn,
  rowNumber,
  maxBidCents,
  auctionLive
}) => {
  const isOwnHighestBid = isOwn && bidAmountCents === maxBidCents;
  const isHighestBid = rowNumber === 0;

  let borderStyle = undefined;

  if ((isHighestBid || isOwnHighestBid) && auctionLive) {
    if (isOwnHighestBid) {
      if (isHighestBid) {
        borderStyle = `1px solid ${COLORS.turquoise}`;
      } else {
        borderStyle = `1px solid ${COLORS.pink70}`;
      }
    } else if (isHighestBid) {
      borderStyle = `1px solid ${COLORS.primaryLight70}`;
    }
  }

  let bgColor = '';

  if (isHighestBid && !auctionLive) {
    bgColor = COLORS.turquoise;
  } else if (isOwnHighestBid) {
    if (isHighestBid) {
      bgColor = COLORS.turquoise08;
    } else {
      bgColor = COLORS.pink08;
    }
  } else if (rowNumber % 2 === 0) {
    bgColor = '#2b2b2c';
  }

  return (
    <div
      style={{
        backgroundColor: bgColor,
        borderBottom: borderStyle,
        borderTop: borderStyle
      }}
      className={classNames('d-flex text-light w-100 px-2 py-3', {
        'text-turquoise': isOwn && isHighestBid && auctionLive,
        'text-pink': isOwnHighestBid && !isHighestBid,
        'text-dark': isHighestBid && !auctionLive
      })}
    >
      <div className='w-10'>{bidNumber}</div>
      <div className='w-20 d-flex flex-column'>
        <div className='text-start'>{isOwn ? 'Your bid' : bidder}</div>
        {isOwn && isHighestBid && maxBidCents && <div className='text-start opacity-60'>Your max</div>}
      </div>
      <div className='w-25 d-flex flex-column'>
        <div className='text-start'>{formatPrice(bidAmountCents)}</div>
        {isOwn && isHighestBid && maxBidCents && (
          <div className='text-start opacity-60'>{formatPrice(maxBidCents)}</div>
        )}
      </div>
      <div className='w-45 opacity-60'>{timePlaced}</div>
    </div>
  );
};
